
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnCheck from "@/components/scope/btn-check.vue";
import { priceRulesEl, partsQuantityRules } from "@common/src/utils/verify";
import { InjectFunction } from "@common/src/utils/decorator";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const setting = namespace("setting");
const common_base = namespace("common_base");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit")
@Component({
  components: { BtnCheck, MyCheckbox }
})
export default class OutWarehouseEdit extends Vue {
  @setting.State serviceMode;
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @parts.Action getPartsDetail;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @inventory.Action getOutWarehouseDetail;
  @inventory.Action outWarehouseComplete;
  @inventory.Action queryInventoryAndNotice;
  @user.State userData;
  @base.Action getDictionaryList;
  @inventory.Action saveOutWarehouse;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  get breadData() {
    return [
      { name: t("warehouse.outbound-manage"), path: "/inventory/out-warehouse" },
      { name: this.isAdd ? t("v210801.new-out-warehouse-order") : t("v210801.edit-out-warehouse-order") }
    ];
  }
  get isAdd() {
    return this.$route.name === "outWarehouseAdd";
  }
  orderFormDataRules = {
    outboundType: [{ required: true, message: t("v210801.pls-select-outbound-type"), trigger: "change" }]
  };
  shelfPartsMap: any = {};
  handleQtyCheck(row, prop) {
    let seletedWarehouse = row.list.find(item => row.warehouseCode === item.warehouseCode);
    let selectedShelf = seletedWarehouse
      ? seletedWarehouse.shelfList.find(item => row.shelfCode === item.shelfCode)
      : null;
    if (selectedShelf) {
      // 如果有选择的仓库，才判断
      if (row.qty > selectedShelf.qty) {
        if (prop === "qty") {
          row.showQtyTips = true;
        } else {
          row.showWarehouseTips = true;
        }
        setTimeout(() => {
          row.showQtyTips = false;
          row.showWarehouseTips = false;
        }, 3000);
      } else {
        row.showQtyTips = false;
        row.showWarehouseTips = false;
      }
    }
  }
  get isStandardModeSaleType() {
    // 销售领料不能选择其他零配件
    return !this.isAdd && this.serviceMode === "1" && this.orderFormData.outboundType === "2";
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any[] = [{}];
  orderFormData: any = {
    outboundType: "3",
    outboundUser: "",
    remark: "",
    detailList: [],
    costAmount: "0"
  };
  get isAutomaticGeneratedOrder() {
    return !!this.orderFormData.orderNo;
  }
  get isEditUnitPrice() {
    return false;
  }
  definitionPartsData: any = {
    partsInfo: {},
    costAmount: "",
    qty: "",
    totalInventory: 0,
    costPrice: "",
    partsCode: "",
    warehouseCode: "",
    shelfCode: "",
    remark: "",
    list: [],
    shelfList: [],
    manual: true
  };

  serviceItemList: any[] = [];

  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }

  created() {
    this.setPBPX(52);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  outWarehouseTypeList: any = [];
  async init() {
    this.getDictionaryList("outbound_type").then(data => {
      // 新增，只保留其他出库选项
      this.outWarehouseTypeList = data.filter(item => !this.isAdd || (this.isAdd && item.dataValue === "3"));
    });
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.getOutWarehouseDetail({
        outboundNo: this.orderId
      }).then(data => {
        this.orderFormData = data.data;
        data.data.detailList.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push(item);
          }
        });
        data.data.detailList.forEach((item, index) => {
          this.handleChooseParts(item.partsCode, index, item, "init");
        });
        if (!this.isStandardModeSaleType) {
          this.getPartsLists("");
        }
      });
    } else {
      this.getPartsLists("");
      this.orderFormData.outboundUser = this.userData.userCode;
    }
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
    });
  }
  computedAmount(index) {
    let costAmount = (this.orderFormData.detailList[index].qty || 0) * this.orderFormData.detailList[index].costPrice;
    this.orderFormData.detailList[index].costAmount = costAmount.toFixed(2);
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.detailList.reduce((preV, curV) => preV + Number(curV.costAmount), 0);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.costAmount = partsTotal.toFixed(2);
  }
  searchParts(val) {
    if (this.isStandardModeSaleType) {
      return false;
    }
    this.getPartsLists(val);
  }

  emitComplete(orderId?) {
    let outboundNo = orderId || this.orderId;
    this.outWarehouseComplete({
      outboundNo: outboundNo,
      _httpOptions: { errorMessage: false }
    })
      .then(
        data => {
          this.$message.success(t("warehouse.outbound-success"));
          if (data.data.validateInventoryAlert === "1") {
            const partsCodeList = this.orderFormData.detailList.map(item => item.partsCode);
            if (partsCodeList && partsCodeList.length > 0) {
              this.queryInventoryAndNotice(partsCodeList);
            }
          }
          this.showOutConfirmTips = false;
          this.$router.push(`/inventory/out-warehouse-view/${outboundNo}`);
        },
        res => {
          this.showOutConfirmTips = false;
          if (res.code === "speedbiz.inventory.outbound-cost-changed") {
            this.$confirm(res.message, t("v210831.tips"), {
              confirmButtonText: t("v216_6.continue-outbound"),
              cancelButtonText: t("v216_6.temporarily-not-outbound"),
              type: "warning"
            })
              .then(() => {
                this.emitComplete();
              })
              .catch(() => {
                this.init();
              });
          } else {
            this.$message.error(res.message);
          }
        }
      )
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleChooseParts(val, index, row, type = "manual") {
    if (!this.shelfPartsMap[val]) {
      this.shelfPartsMap[val] = [];
    }
    this.queryPartsQtyByWarehouseTree({
      partsCode: val
    }).then(data => {
      const warehouseList = this.$safeValue(data, "data.warehouseList", []);
      const defaultWarehouse = warehouseList.find(item => item.defaultWarehouse === 1);
      const partsInfo = warehouseList[0];
      let partsData = Object.assign(
        {},
        row,
        {
          partsCode: val,
          partsInfo: partsInfo,
          list: warehouseList,
          totalInventory: data.data.inventoryQty
        },
        { showQtyTips: false, showWarehouseTips: false }
      );
      if (type === "manual") {
        partsData.qty = "";
        partsData.costAmount = "";
        partsData.warehouseCode = "";
        partsData.shelfCode = "";
        partsData.costPrice = partsInfo.costPrice;
        if (defaultWarehouse) {
          partsData.warehouseCode = defaultWarehouse.warehouseCode;
          this.handleWarehouseChange(partsData, type);
        }
      } else {
        this.handleWarehouseChange(partsData, type);
        partsData.costPrice = row.costPrice || "";
        partsData.costAmount = row.costAmount || "";
      }
      this.orderFormData.detailList.splice(index, 1, partsData);
      this.computedAmount(index);
      // list:[] 编辑的时候不验证库存
      // this.handleQtyCheck({ list: [], partsCode: partsData.partsCode }, "warehouse");
    });
  }

  checkAddData(): boolean {
    if (!this.orderFormData.outboundType) {
      this.$message.error(t("v210801.pls-select-outbound-type"));
      return false;
    }
    if (this.orderFormData.detailList.length < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.detailList.length; index++) {
      const element = this.orderFormData.detailList[index];
      if (!element.partsCode) {
        this.$message.error(t("v210831.please-select-stock-output-parts"));
        return false;
      }
      if (!element.qty) {
        this.$message.error(t("v210831.please-fill-in-output-parts-munber"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }

      if (!element.warehouseCode || !element.shelfCode) {
        this.$message.error(t("v213.please-select-the-outbound-warehouse/location"));
        return false;
      }
      if (this.operationName === "complete") {
        const selectedWarehouse = element.list.find(item => item.warehouseCode === element.warehouseCode);
        const selectedShelf = element.shelfList.find(item => item.shelfCode === element.shelfCode);
        if (Number(element.qty) > selectedShelf.qty) {
          this.$message.error(
            `${selectedWarehouse.warehouseName}${t("warehouse.warehouse")}/${selectedShelf.shelfDesc}${t(
              "v213.insufficient-inventory-at-location-please-confirm"
            )}`
          );
          return false;
        }
      }
    }
    return true;
  }
  operationName: string = "";
  handleComplete() {
    this.operationName = "complete";
    this.emitSaveOutWarehouse();
  }
  handleSaveOutWarehouse() {
    this.operationName = "save";
    this.emitSaveOutWarehouse();
  }
  emitSaveOutWarehouse() {
    (this.$refs["outWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        this.saveOutWarehouse(this.orderFormData)
          .then(data => {
            if (this.operationName === "save") {
              this.$message.success(t("base.save-success") as string);
              this.$router.push(`/inventory/out-warehouse-view/${data.data.outboundNo}`);
            } else {
              this.emitComplete(data.data.outboundNo);
            }
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleAddParts() {
    this.orderFormData.detailList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
    this.updateShelfEnableMap();
  }
  handleShelfSelectFocus(row) {
    if (!row.warehouseCode) {
      this.$message.error(t("v213.please-select-spare-parts-and-outbound-warehouse-first"));
    }
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  handleShelfChange(row) {
    this.updateShelfEnableMap();
    this.handleQtyCheck(row, "shelf");
  }
  // 当仓库和库位发生变化更新零配件和库位的映射，即同一个零配件和相同库位只能存在一行
  updateShelfEnableMap() {
    let tempMap = {};
    this.orderFormData.detailList.forEach(item => {
      let curShelfCode = item.shelfCode;
      if (!tempMap[item.partsCode]) {
        tempMap[item.partsCode] = [];
      }
      curShelfCode && tempMap[item.partsCode].push(curShelfCode);
    });
    this.shelfPartsMap = tempMap;
  }

  checkShelfEnable(partsRow, shelfRow) {
    return (
      this.shelfPartsMap[partsRow.partsCode].includes(shelfRow.shelfCode) && partsRow.shelfCode !== shelfRow.shelfCode
    );
  }
  // 2.10
  showOutConfirmTips: boolean = false;
  handleShowOutConfrimTips() {
    this.operationName = "complete";
    (this.$refs["outWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.showOutConfirmTips = true;
      }
    });
  }
  handleWarehouseChange(row, type = "manual") {
    let seletedWarehouse = row.list.find(item => row.warehouseCode === item.warehouseCode);
    row.shelfList = seletedWarehouse && seletedWarehouse.shelfList;
    const defaultShelf = row.shelfList.find(item => item.defaultShelf === 1);
    if (type === "manual") {
      if (defaultShelf && !this.checkShelfEnable(row, defaultShelf)) {
        row.shelfCode = defaultShelf.shelfCode;
      } else {
        row.shelfCode = "";
      }
    }
    this.updateShelfEnableMap();
  }
}
